import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const SAVE_NEW_BILLING_DATA_AS_SEEN = "SAVE_NEW_BILLING_DATA_AS_SEEN";

export const service = async (eaCaseIds) => {
  const options: object = {
    url: '/Api/EaCaseApiController/SaveNewBillingDataAsSeen',
    method: "POST",
    body: JSON.stringify(eaCaseIds),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SAVE_NEW_BILLING_DATA_AS_SEEN, service, mock);
